import React from 'react';
import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import StreamForm from "../../../components/data_products/streams/StreamForm";
import StreamAnalytics from '../../../components/data_products/streams/StreamAnalytics';
import { useGetStreamAnalyticsQuery, useGetStreamQuery } from '../../../api/streamApiSlice';
import {useControlledTabs} from "../../../components/Tabs";
import {useDifactoBucket} from "../../../components/utils";

export default function Stream(props) {
  const { t } = useTranslation();
  const { streamId } = useParams();
  const { data: stream, isSuccess } = useGetStreamQuery(streamId)
  const [tabProps,] = useControlledTabs("stream", props)
  const bucket = useDifactoBucket();

  const {
    data: stats,
    isSuccess: isStatsSuccess,
    isError: isStatsError,
    refetch: refetchStats
  } = useGetStreamAnalyticsQuery(
    streamId,
    {
      refetchOnMountOrArgChange: true,
    }
  )

  if( !isSuccess ) { return (<></>) }
  return (
    <>
      <Title main={t("menu.streams")} sub={stream.name} backPath="/streams">
        <FormButton edit state={{activeTab: tabProps.active}}/>
      </Title>
      <StreamForm
        stream={stream}
        disabled
        tabProps={tabProps}
        bucket={bucket}
        extraTabs={[
          <StreamAnalytics
            as="analytics"
            icon="chart"
            stream={stream}
            stats={stats}
            isSuccess={isStatsSuccess}
            isError={isStatsError}
            retry={refetchStats}
          />]}
      />
    </>
  )
}
